"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.searchProviderActions = exports.initialState = void 0;
const unset_1 = __importDefault(require("lodash/unset"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const isArray_1 = __importDefault(require("lodash/fp/isArray"));
const slices_1 = require("../../utils/@reduxjs/slices");
const api_1 = require("../../utils/api");
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const types_1 = require("./types");
const REDUCER_KEY = 'searchProvider';
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    data: {
        entries: [],
        entriesEvents: [],
        entriesTournaments: [],
        fetchItems: api_1.requestInitialState,
    },
    sportId: 0,
    search: '',
    searchType: types_1.SearchTabsType.Events,
    searchQuery: {},
    isFocusInput: false,
    recentSearch: [],
    searchLine: '',
    isTournaments: false,
});
const searchProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchSearch(state) {
            state.data.fetchItems.loading = true;
            state.data.fetchItems.error = null;
        },
        fetchSearchMainSuccess(state, { payload }) {
            state.data.entries = payload.items;
            state.data.fetchItems.loading = false;
            state.data.fetchItems.error = null;
        },
        fetchSearchMainError(state, { payload }) {
            state.data.entries = [];
            state.data.fetchItems.loading = false;
            state.data.fetchItems.error = payload;
        },
        setSearchMain(state, { payload }) {
            state.search = payload.valueSearch;
            state.data.fetchItems.error = null;
        },
        setSearchLine(state, { payload }) {
            state.searchLine = payload.valueSearch;
            state.sportId = payload.sportId || 0;
            state.isTournaments = payload.isTournaments || false;
            state.data.fetchItems.error = null;
        },
        setSearchQuery(state, { payload: { eventId, value } }) {
            state.searchQuery = {
                ...state.searchQuery,
                ...{ [eventId]: value },
            };
        },
        deleteIdSearchQuery(state, { payload }) {
            (0, unset_1.default)(state.searchQuery, `${payload.eventId}`);
        },
        fetchSearchSuccess(state, { payload }) {
            var _a, _b;
            state.data.entriesEvents = ((_a = payload.entriesEvents) === null || _a === void 0 ? void 0 : _a.items) || [];
            state.data.entriesTournaments = ((_b = payload.entriesTournaments) === null || _b === void 0 ? void 0 : _b.items) || [];
            state.data.fetchItems.loading = false;
            state.data.fetchItems.error = null;
            state.isFocusInput = false;
        },
        fetchSearchError(state, { payload }) {
            state.data.entriesEvents = [];
            state.data.entriesTournaments = [];
            state.data.fetchItems.loading = false;
            state.data.fetchItems.error = payload;
            state.isFocusInput = false;
        },
        setSearch(state, { payload }) {
            state.search = payload.valueSearch;
            state.data.fetchItems.error = null;
        },
        setSearchTab(state, { payload }) {
            state.searchType = payload.tab;
            state.data.fetchItems.error = null;
        },
        setSearchIsFocusInput(state, { payload }) {
            state.isFocusInput = payload;
            state.data.fetchItems.error = null;
        },
        setRecentSearch(state, { payload }) {
            if ((0, isArray_1.default)(payload)) {
                state.recentSearch = payload;
            }
            else {
                state.recentSearch = (0, uniq_1.default)([payload, ...state.recentSearch]);
            }
        },
    },
});
exports.searchProviderActions = searchProviderSlice.actions, exports.reducer = searchProviderSlice.reducer, exports.sliceKey = searchProviderSlice.name;
//# sourceMappingURL=slice.js.map